export const unmask = (string: string) =>
  string
    .replace(/\./g, '')
    .replace(/-/g, '')
    .replace(/\)/g, '')
    .replace(/\(/g, '')
    .replace(/\//g, '')
    .replace(/\s/g, '')
    .replace(/_/g, '')
